import { useCallback } from "react";

import type { KaiTablePrefsPatch } from "@/components/table";
import { applyKaiBookingsTablePrefs } from "@/features/bookings/bookingTablePrefs";

/**
 * Applies a table-preferences patch requested by Kai (via the
 * `apply_table_preferences` SSE event) to the target page's localStorage
 * prefs. A mounted table picks up the change via the `kai-table-prefs`
 * window event. Unknown pages or malformed payloads are ignored.
 */
export function useApplyKaiTablePreferences() {
  return useCallback((page: unknown, preferences: unknown) => {
    if (typeof page !== "string") return;
    if (!preferences || typeof preferences !== "object") return;
    const patch = preferences as KaiTablePrefsPatch;
    if (page === "bookings") {
      applyKaiBookingsTablePrefs(patch);
    }
  }, []);
}
